import { api } from "api/api";
import { AxiosError } from "axios";
import CondicaoPagamento from "model/fiscal/CondicaoPagamento";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class CondicaoPagamentoService implements BaseServiceCadastros<CondicaoPagamento> {

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/condicaoPagamento/pesquisar`;
            url += getFilters(filters);
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<CondicaoPagamento>((resolve, reject): void => {
            api
                .get(`/condicaoPagamento/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(condicaoPagamento: CondicaoPagamento) {
        return new Promise<CondicaoPagamento>((resolve, reject): void => {
            api
                .post(`/condicaoPagamento/incluir`, JSON.stringify(condicaoPagamento))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(condicaoPagamento: CondicaoPagamento) {
        return new Promise<CondicaoPagamento>((resolve, reject): void => {
            api
                .put(`/condicaoPagamento/editar`, JSON.stringify(condicaoPagamento))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/condicaoPagamento/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

}
export default CondicaoPagamentoService;
